import ReactModal from 'react-modal';
import { EMAIL_VALIDATION_STATUSES } from './email-validation-statuses';
import General from '../utils/GeneralUtils';
import UniversalTag from './UniversalTag';
import './RevalidateEmailsSlideout.scss';

interface RevalidateEmailsSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function RevalidateEmailsSlideout({ isOpen, onClose }: RevalidateEmailsSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 500px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="revalidate-emails-slideout">
        <div className="header">
          <h3>About Email Re-Validation</h3>
        </div>

        <div className="section">
          <h4>What is email re-validation?</h4>
          <p>
            Email re-validation runs a fresh deliverability check on all email addresses in your export
            using a third-party verification service (ZeroBounce or NeverBounce). This ensures you have
            the most current validation status before sending to your CRM or downloading.
          </p>
        </div>

        <div className="section">
          <h4>What happens during re-validation?</h4>
          <ul>
            <li>Each email is checked against the verification provider's database</li>
            <li>The provider attempts to verify the mailbox exists without sending an email</li>
            <li>Results are returned with statuses like Valid, Invalid, Catch-All, etc.</li>
            <li>You can choose to skip contacts with invalid emails or include them with a warning</li>
          </ul>
        </div>

        <div className="section">
          <h4>Limits</h4>
          <p>
            Every email in a re-validated export counts toward your team's monthly email verification
            limit. If an export has more emails than you have left this month, the rest keep their
            existing validation status.
          </p>
        </div>

        <div className="section">
          <h4>ZeroBounce vs NeverBounce</h4>
          <p>
            Both services provide accurate email validation. ZeroBounce tends to be more conservative,
            flagging more emails as risky. NeverBounce is generally faster and slightly more lenient.
            Either choice works well for most use cases.
          </p>
        </div>

        <div className="section">
          <h4>Skip re-validation</h4>
          <p>
            If you choose to skip, your export will use the existing email validation status stored
            in Edulead. This is faster and doesn't consume additional validation credits, but the
            status may be outdated.
          </p>
        </div>

        <div className="section all-statuses">
          <h4>Validation statuses</h4>
          <table>
            <tbody>
              {EMAIL_VALIDATION_STATUSES.map((statusInfo) => (
                <tr key={statusInfo.key}>
                  <td className="status-cell">
                    <UniversalTag category={statusInfo.key} />
                  </td>
                  <td className="desc">{statusInfo.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </ReactModal>
  );
}
